import { useCallback, useState } from "react";
import useFetch from "../../hooks/useFetch";
import { useShowNotification } from "../Common/showNotification";

function useGetAiImage() {
  const [fetchWrapper] = useFetch();
  const showNotification = useShowNotification();

  const [abortController, setAbortController] = useState(new AbortController());

  const getAiImage = useCallback(
    (
      image_id,
      timeout_duration,
      plates,
      selectedPlateIndex,
      getPlates,
      setIsLoading,
      setLoadingTip
    ) => {
      setIsLoading(true);
      setLoadingTip("Analyzing Image...");

      let timeout_id = setTimeout(() => {
        //Abort summary, energy consumption distribution, and device list's fetch request
        abortController.abort("");
        //Assign a new abort controller
        setAbortController(new AbortController());
      }, timeout_duration * 1000);

      fetchWrapper({
        endpoint_url: "image/getAIImage",
        abort_controller: abortController,
        params: {
          image_id: image_id,
          timeout: timeout_duration,
        },
        onSuccess: (fetch_output) => {
          clearTimeout(timeout_id);
          setIsLoading(false);
          if (!("error" in fetch_output)) {
            let data = fetch_output["data"];
            let cloned_plates = JSON.parse(JSON.stringify(plates));
            cloned_plates[selectedPlateIndex] = data;

            getPlates(cloned_plates);
          } else {
            showNotification({
              message: "Unexpected error.",
              description: "Please try again later or contact admin.",
            });
          }
        },
        onResponseError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to analyze image.",
            description: "Please try again later or try on a new image.",
          });
        },
        onFetchError: () => {
          setIsLoading(false);
          showNotification({
            message: "Failed to analyze image.",
            description: "Please try again later or try on a new image.",
          });
        },
      });
    },
    [fetchWrapper]
  );

  return { getAiImage };
}

export default useGetAiImage;
